import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-jinni-tooltip',
  templateUrl: './jinni-tooltip.component.html',
  styleUrls: ['./jinni-tooltip.component.scss']
})
export class JinniTooltipComponent implements OnInit, AfterViewInit {
  jinniTooltip: Subscription;
  tooltipData: any;
  tooltipHeight: number;
  showModal: boolean;
  @ViewChild('tooltip') elementView: ElementRef;
  constructor(private subscriptionsService: SubscriptionsService) {
      this.showModal = false;
      this.tooltipData = { top: 0 , left: 0, show: false, message: '' };
      this.jinniTooltip = this.subscriptionsService.getJinniTooltip().subscribe( data => {
        this.tooltipData = data;
        if (this.tooltipData.show && this.tooltipData.message !== '') {
            setTimeout(() => {
                this.showModal = true;
            }, 5);
        } else {
            this.showModal = false;
        }
      });
  }

  ngOnInit() {
  }

  closeTooltip() {
      this.tooltipData = { top: '0' , left: '0', show: false, message: '' };
  }

    ngAfterViewInit(): void {
        this.subscriptionsService.getJinniTooltip().subscribe( data => {
            setTimeout(() => {
                if (this.elementView && this.elementView.nativeElement) {
                    this.tooltipData = data;
                    this.tooltipHeight = this.elementView.nativeElement.offsetHeight;
                    this.tooltipData.top = (this.tooltipData.top * 1) - (this.tooltipHeight / 2);
                }
            }, 1);
        });
    }
}
